import styled from "styled-components";

export const StyledFormFooter = styled.footer`

    display: flex;
    justify-content: space-between;
    align-items: center;

`